module.exports = __webpack_public_path__ + "static/media/01_.8b369a16.png";